<div class="article-invoice-amount">
  <div class="article-invoice-amount__chart-panel">
    <div class="overview-item">
      <div class="title">{{ 'INVOICE.SUMMARY_PER_ARTICLE' | translate }}</div>
      <div class="article-invoice-amount__chart">
        <div class="chart" #chart></div>
      </div>
    </div>
  </div>
  <div>
    <div class="invoice-overview-section overview-item article-invoice-amount__articles">
      @for (model of articles; track model) {
        <div class="article">
          <div class="marker" [style.background]="model.marker"></div>
          <div class="article__content">
            <span class="title">{{ model.title }}</span>
            <app-money-box [dataContext]="model.amount"></app-money-box>
          </div>
        </div>
      }
    </div>
  </div>
</div>
